import { render, staticRenderFns } from "./pageElementDropdown.vue?vue&type=template&id=243c4bc2&scoped=true&"
import script from "./pageElementDropdown.vue?vue&type=script&lang=js&"
export * from "./pageElementDropdown.vue?vue&type=script&lang=js&"
import style0 from "./pageElementDropdown.vue?vue&type=style&index=0&id=243c4bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243c4bc2",
  null
  
)

export default component.exports